import t from '@/themes/theme.js'

export default {
  computed: {
    computedThemeArr() {
      if(this.$store.state.settings.theme) {
        var split = this.$store.state.settings.theme.split('-');
        return split;
      } else {
        return ['default', 'light'];
      }
    },
    computedThemeMode() {
      return this.computedThemeArr[1];
    },
    computedThemeColor() {
      return this.computedThemeArr[0];
    },
    themeTextColor() {
      if(this.computedThemeMode === 'dark') {
        return '#fff';
      } else {
        return 'rgba(0, 0, 0, 0.87)';
      }
    },
    themePrimaryColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.primary;
      } else {
        return t[this.computedThemeColor].primary;
      }
    },
    themeSecondaryColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.secondary;
      } else {
        return t[this.computedThemeColor].secondary;
      }
    },
    themeSuccessColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.success;
      } else {
        return t[this.computedThemeColor].success;
      }
    },
    themeInfoColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.info;
      } else {
        return t[this.computedThemeColor].info;
      }
    },
    themeWarningColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.warning;
      } else {
        return t[this.computedThemeColor].warning;
      }
    },
    themeErrorColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.error;
      } else {
        return t[this.computedThemeColor].error;
      }
    },
    themeTrackColor() {
      if(this.computedThemeColor === 'custom') {
        return this.$store.state.settings.custom.track;
      } else {
        return t[this.computedThemeColor].track;
      }
    },
  }
};